import { useTheme } from '@emotion/react';
import { Box, Stack, TablePagination, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import GraphActions from './components/GraphActions';
import EUATradeDetails from './components/EUATradeDetails';
import { checkPermission } from '../../../redux/features/authSlice';
import AccessDenied from '../AccesDenied/AccessDenied';
import PortfolioList from './components/PortfolioList';

export default function PortfolioManagement() {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const { t } = useTranslation();

  const { companyDetails, user } = useSelector((state) => state.auth);

  const requestPermission = useSelector((state) => checkPermission(state, 'Trade Management', 'Manage Requests'));
  const approvalPermission = useSelector((state) => checkPermission(state, 'Trade Management', 'Manage Approvals'));

  return (requestPermission.viewAccess || approvalPermission.viewAccess) && (companyDetails?.euaTrading || user?.companyTraderLength > 0 || user?.permissions[0]?.roleName === 'admin') ? (
    <Stack
      flex={1}
      direction={'row'}
      className="m-[8px] rounded-[8px] bg-white flex-1 min-h-0"
    >
      <Stack
        flex={0.6}
        style={{ borderRightWidth: '1px', borderColor: 'rgba(188, 188, 188, 0.36)' }}
      >
        <Stack
          flex={0.4}
          style={{ borderBottomWidth: '1px', borderColor: 'rgba(188, 188, 188, 0.36)' }}
        >
          <Stack
            style={{ height: '56px', width: '100%', borderBottomWidth: '1px', borderColor: 'rgba(188, 188, 188, 0.36)' }}
            direction={'row'}
            alignItems={'center'}
          >
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize !px-[26px] "
              color={'#14285A'}
            >
              {t('EUA TRADE DETAILS')}
            </Typography>
          </Stack>
          <EUATradeDetails />
        </Stack>
        <Stack flex={0.6}>
          <Typography
            className="fs-14 ff-Roboto fw-medium capitalize !mx-[26px] !mt-[16px]"
            color={text}
          >
            {t('PORTFOLIO LIST')}
          </Typography>
          <PortfolioList />
        </Stack>
      </Stack>
      <Stack
        flex={0.4}
        className="flex-y-overflow"
      >
        <GraphActions />
      </Stack>
    </Stack>
  ) : (
    <AccessDenied />
  );
}
